export default "__VITE_ASSET__e3cfa8c3__"